var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTime = function SvgTime(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 34 34"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#282D2D",
    stroke: "#282D2D",
    strokeWidth: 0.5,
    d: "m23.129 21.997.008-.01.006-.01c.343-.513.16-1.106-.245-1.43l-.009-.007-4.413-3.216V7.968c0-.275-.135-.529-.315-.71a1.03 1.03 0 0 0-.71-.314h-.903c-.603 0-1.024.512-1.024 1.024V18.29c0 .15.019.295.073.437a1.1 1.1 0 0 0 .258.385l.015.015.016.011 5.286 3.803c.23.181.516.219.766.167a.97.97 0 0 0 .62-.414zM17 .75C8.023.75.75 8.023.75 17S8.023 33.25 17 33.25 33.25 25.977 33.25 17 25.977.75 17 .75ZM30.686 17c0 7.54-6.147 13.686-13.686 13.686-7.54 0-13.685-6.083-13.685-13.686C3.315 9.524 9.398 3.315 17 3.315c7.476 0 13.686 6.146 13.686 13.685Z"
  })));
};
export default SvgTime;